
import { Component, Vue, Watch } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import PickerDate from '@/components/picker-date.vue';
import Dialog from '@/components/dialog.vue';
import Message from '@/components/message.vue';
import UploadImg from '@/components/upload-img.vue';
import memberTable from './member-table.vue';
import previewImg from '@/components/previewImg.vue';
import { imgHost } from "@/utils/config"

import {
	activityPKRankingSave,
	chooseMemberList,
	activityPKRankingInfo
} from '@/api/toBApi';

@Component({
	name: '',
	components: {
		PageFooter,
		PickerDate,
		memberTable,
		UploadImg,
		previewImg,
		'slz-dialog': Dialog,
		'slz-message': Message,
	}
})


export default class PKRANKINGDETAILS extends Vue {

	private checkDateValue: any = (rule, value, callback) => {
		let start = value[0];
		let end = value[1];
		console.log(this.formData)
		if (!start || !end) {
			return callback(new Error('请完善活动时间'));
		} else if (new Date(start).getTime() > new Date(end).getTime()) {
			return callback(new Error('请设置正确的活动时间'));
		} else {
			return callback();
		}
	};


	private imgUrl = imgHost;
	private pageLoading = false;
	private currentUrl = '';
	private showPreview = false;

	private formData: any = {
		Id: 0,
		Name: '',
		StartTime: '',
		EndTime: '',
		RoleGrade: undefined,
		PerformanceType: undefined,
		EntrancePosterImgUrl: '',
		EntrancePosterImgWidth: 0,
		EntrancePosterImgHeight: 0,
		HeaderImgUrl: '',
		HeaderImgWidth: 0,
		HeaderImgHeight: 0,
		SharePosterBackGroundImgUrl: '',
		ActivityPKRankingTeamDtos: []
	}
	private rules: any = {
		Name: [
			{ required: true, message: '请输入活动名称', trigger: 'change' }
		],
		StartTime: {
			required: true, message: '请完善活动时间', trigger: 'change'
		},
		EndTime: {
			required: true, message: '请完善活动时间', trigger: 'change'
		},
		RoleGrade: [
			{ required: true, message: '请选择PK级别', trigger: 'change' }
		],
		PerformanceType: [
			{ required: true, message: '请选择PK指标', trigger: 'change' }
		],
		TeamName: [
			{ required: true, message: '请输入队伍名称', trigger: 'change' }
		],
		EntrancePosterImgUrl: [
			{ required: true, message: '请上传入口海报图', trigger: 'change' }
		],
		SharePosterBackGroundImgUrl: [
			{ required: true, message: '请上传PK榜分享海报背景图', trigger: 'change' }
		]
	}

	private roleGradeValues = ['', '联创', '核心', '总代'];

	private showDialog = false;
	private pageNo = 1;
	private pageSize = 10;
	private roleGrade = 0;
	private keywords = '';
	private loading = false;
	private list = [];
	private total = 0;
	private selectionList = [];
	private selectedIndex = 0;

	private isCopy = false;
	private infoId = 0;

	@Watch('formData.EntrancePosterImgUrl')
	private entrancePosterImgUrlChange() {
		let url = this.formData.EntrancePosterImgUrl;
		if (!url) {
			this.formData.EntrancePosterImgWidth = 0;
			this.formData.EntrancePosterImgHeight = 0;
		} else {
			let image = new Image();
			image.onload = () => {
				this.formData.EntrancePosterImgWidth = image.width;
				this.formData.EntrancePosterImgHeight = image.height;
				console.log(this.formData.EntrancePosterImgWidth, this.formData.EntrancePosterImgHeight)
			}
			image.src = this.imgUrl + url;
		}
	}
	@Watch('formData.HeaderImgUrl')
	private headerImgUrlChange() {
		let url = this.formData.HeaderImgUrl;
		if (!url) {
			this.formData.HeaderImgWidth = 0;
			this.formData.HeaderImgHeight = 0;
		} else {
			let image = new Image();
			image.onload = () => {
				this.formData.HeaderImgWidth = image.width;
				this.formData.HeaderImgHeight = image.height;
			}
			image.src = this.imgUrl + url;
		}
	}

	private mounted() {
		const route: any = this.$route;
		if (route.query.id) {
			this.infoId = route.query.id;
			if (route.query.copy){
				this.isCopy = true;
			}
			this.getDetails();
		}
	}

	private async getDetails() {
		try {
			this.pageLoading = true;
			const res: any = await activityPKRankingInfo({ ActivityPKRankingId: this.infoId });
			res.Result.ActivityPKRankingTeamDtos.map(item => {
				item.ActivityPKRankingTeamMemberDtos.map(obj => {
					obj.Id = obj.MemberId;
					return obj;
				})
				return item;
			})

			if (this.isCopy){
				res.Result.Id = 0;
				res.Result.StartTime = '';
				res.Result.EndTime = '';
			}
			
			this.formData = res.Result;
			this.$nextTick(() => {
				let ref: any = this.$refs['form1'];
				ref.clearValidate();
			})
			console.log(this.formData)
		} catch (e) {
			console.log(e)
		} finally {
			this.pageLoading = false;
		}
	}

	private handleAddTeam() {
		if (this.formData.ActivityPKRankingTeamDtos.length === 20) {
			this.$message.error('1场活动最多添加20个队伍');
			return;
		}

		this.formData.ActivityPKRankingTeamDtos.push({
			TeamId: 0,
			TeamName: '',
			ActivityPKRankingTeamMemberDtos: []
		})
	}

	private navBack() {
		this.$router.replace({
			name: 'PKRanking'
		})
	}
	private async handleSave() {
		await this.formValidate('form1');

		if (this.formData.ActivityPKRankingTeamDtos.length < 1) {
			this.$message.error('至少添加2个队伍');
			return;
		}

		await this.formValidate('form2');
		await this.formValidate('form3');

		this.saveData();
	}

	private async saveData() {
		try {
			this.pageLoading = true;
			this.formData.ActivityPKRankingTeamDtos.map(item => {
				item.ActivityPKRankingTeamMemberDtos.map(obj => {
					obj.MemberId = obj.Id;
					return obj;
				})
				return item;
			})
			const res: any = await activityPKRankingSave(this.formData)
			this.$message.success("操作成功");
			this.navBack();
		} catch (e) {
			console.log(e)
		} finally {
			this.pageLoading = false;
		}
	}

	private formValidate(formName: string) {
		return new Promise((resolve, reject) => {
			let ref: any = this.$refs[formName];
			ref.validate((valid) => {
				if (valid) {
					resolve(true);
				} else {
					setTimeout(()=>{
						let query = document.querySelector('.el-form-item__error');
						console.log(query)
						query.scrollIntoView({block: "center"});
					}, 500)
					this.$message.error('请完善活动配置');
					reject(false);
				}
			});
		})

	}

	private handlePreview(url){
		this.showPreview = true;
		this.currentUrl = url;
	}
	private uploadSucess(list: any, key: string) {
		this.formData[key] = list[0]
	}
	private handleDeleteTeam(index) {
		this.formData.ActivityPKRankingTeamDtos.splice(index, 1)
	}
	private memberChange(list, index) {
		this.formData.ActivityPKRankingTeamDtos[index].ActivityPKRankingTeamMemberDtos = list;
	}

	//选择代理
	private handleSearch() {
		this.pageNo = 1;
		this.getAgentList();
	}
	private changePage(e) {
		this.pageNo = e
		this.getAgentList();
	}
	private selectionChange(selection) {
		this.selectionList = selection;
	}
	private handleCancel() {
		this.showDialog = false;
	}
	private handleSure() {
		if (!this.selectionList.length) {
			this.$message({
				type: 'warning',
				message: '请选择分销员'
			})
			return;
		}

		this.formData.ActivityPKRankingTeamDtos[this.selectedIndex].ActivityPKRankingTeamMemberDtos = this.selectionList

		this.handleCancel();
	}
	private handleSelectTeamMember(index) {



		this.selectedIndex = index;
		this.pageNo = 1;
		this.roleGrade = this.formData.RoleGrade;

		if (!this.roleGrade) {
			this.$message({
				type: 'warning',
				message: '请先选择PK级别'
			})
			return;
		}

		this.showDialog = true;


		this.$nextTick(() => {
			const ref: any = this.$refs['popTable'];

			let list = this.formData.ActivityPKRankingTeamDtos[this.selectedIndex].ActivityPKRankingTeamMemberDtos
			this.selectionList = list;
			if (list.length) {
				console.log(list, 'list')
				this.$nextTick(() => {
					list.map(item => {
						ref.toggleRowSelection(item, true)
					})
				})

			}

			this.getAgentList();
		})


	}
	private async getAgentList() {
		let params: any = {
			Skip: (this.pageNo - 1) * this.pageSize,
			Take: this.pageSize,
			RoleGrade: this.roleGrade,
			Keywords: this.keywords.trim(),
		}

		try {
			this.loading = true;
			const res: any = await chooseMemberList(params)
			this.list = res.Result.Results.map(item => {
				item.RoleGradeValue = this.roleGradeValues[this.roleGrade];
				item.RoleGrade = this.roleGrade;
				return item;
			});
			this.total = res.Result.Total;
		} catch (e) {
			console.log(e)
		} finally {
			this.loading = false;
		}
	}


	// private handleKeyUp(e, key){
	// 	if (e.keyCode === 13){
	// 		this[key].pageNo = 1;
	// 		this[key].searchKeywords = this[key].keywords;
	// 	}
	// }
	// private async getDetails(){
	// 	this.pageLoading = true;
	// 	try {
	// 		const res: any = await employeeOperatorConfigInfo({Id: this.infoId});
	// 		const {
	// 			EmployeeId,
	// 			FistRoleVisibleType,
	// 			SecondRoleVisibleType,
	// 			FirstChoseMemberList,
	// 			SecondChoseMemberList,
	// 		} = res.Result;

	// 		this.formData.EmployeeId = EmployeeId;
	// 		this.formData.roleFirstType = [3,1,2][FistRoleVisibleType];
	// 		this.formData.roleSecondType = [3,1,2][SecondRoleVisibleType];
	// 		this.firstSelectData.list = FirstChoseMemberList.map(item=>{
	// 			item.Id = item.MemberId;
	// 			return item;
	// 		});
	// 		this.secondSelectData.list = SecondChoseMemberList.map(item=>{
	// 			item.Id = item.MemberId;
	// 			return item;
	// 		});;

	// 	} catch (err) { 

	// 	} finally {
	// 		this.pageLoading = false;
	// 	}
	// }

	// private async getEmployeeList() {
	// 	try {
	// 		const res: any = await employeeList({});
	// 		this.employeeList = res.Result.map(item => {
	// 			item.value = `${item.EmployeeName}(${item.Phone})`;
	// 			return item;
	// 		});
	// 	} catch (err) { }
	// }

	// private selectDataPage(e, key) {
	// 	this[key].pageNo = e;
	// }

	// private handleDeleteItem(record, key){
	// 	let list = this[key].list.filter(item=>{
	// 		return item.Id !== record.Id;
	// 	})
	// 	this[key].list = list;
	// }

	// //选择代理
	// private handleSearch() {
	// 	this.pageNo = 1;
	// 	this.getAgentList();
	// }
	// private changePage(e) {
	// 	this.pageNo = e
	// 	this.getAgentList();
	// }
	// private selectionChange(selection) {
	// 	this.selectionList = selection;
	// }
	// private handleCancel() {
	// 	this.showDialog = false;
	// }
	// private handleSure() {
	// 	if (!this.selectionList.length) {
	// 		this.$message({
	// 			type: 'warning',
	// 			message: '请选择分销员'
	// 		})
	// 		return;
	// 	}
	// 	if (this.roleGrade === 1) {
	// 		this.firstSelectData.list = this.selectionList;
	// 	} else {
	// 		this.secondSelectData.list = this.selectionList;
	// 	}
	// 	this.handleCancel();
	// }
	// private selectAgent(e, type) {
	// 	this.pageNo = 1;
	// 	this.roleGrade = type === 'roleFirstType' ? 1 : 2;
	// 	this.showDialog = true;


	// 	this.$nextTick(()=>{
	// 		const ref: any = this.$refs['popTable'];

	// 		let list = []
	// 		if (this.roleGrade === 1) {
	// 			list = this.firstSelectData.list;
	// 		} else {
	// 			list = this.secondSelectData.list;
	// 		}
	// 		this.selectionList = list;
	// 		if (list.length){
	// 			console.log(list,'list')
	// 			this.$nextTick(()=>{
	// 				list.map(item=>{
	// 					ref.toggleRowSelection(item, true)
	// 				})
	// 			})

	// 		}

	// 		this.getAgentList();
	// 	})


	// }
	// private async getAgentList() {
	// 	let params: any = {
	// 		Skip: (this.pageNo - 1) * this.pageSize,
	// 		Take: this.pageSize,
	// 		RoleGrade: this.roleGrade,
	// 		Keywords: this.keywords.trim(),
	// 	}

	// 	try {
	// 		this.loading = true;
	// 		const res: any = await dataAnalysischoseMemberBox(params)
	// 		this.list = res.Result.Results.map(item=>{
	// 			item.RoleGradeValue = this.roleGrade === 1 ? '联创':'核心';
	// 			item.RoleGrade = this.roleGrade;
	// 			return item;
	// 		});
	// 		this.total = res.Result.Total;
	// 	} catch (e) {
	// 		console.log(e)
	// 	} finally {
	// 		this.loading = false;
	// 	}
	// }


	// private async save(){
	// 	if (this.pageLoading) return;
	// 	this.pageLoading = true;
	// 	try {

	// 		const dt = this.employeeList.filter(item=>{
	// 			return item.Id === this.formData.EmployeeId;
	// 		})

	// 		const res: any = await employeeOperatorConfigSave({
	// 			Id: this.infoId,
	// 			EmployeeId: dt[0].Id,
	// 			EmployeeName: dt[0].EmployeeName,
	// 			Phone: dt[0].Phone,
	// 			FistRoleVisibleType: ['',1,2,0][this.formData.roleFirstType],
	// 			FirstChoseMemberIdList: this.firstSelectData.list.map(item=>{
	// 				return item.Id
	// 			}),
	// 			SecondRoleVisibleType: ['',1,2,0][this.formData.roleSecondType],
	// 			SecondChoseMemberIdList: this.secondSelectData.list.map(item=>{
	// 				return item.Id
	// 			}),
	// 		});

	// 		this.$message.success('操作成功');
	// 		this.$router.replace({
	// 			name: 'employeeAccount'
	// 		})

	// 	} catch (err) { 

	// 	} finally {
	// 		setTimeout(()=>{
	// 			this.pageLoading = false;
	// 		}, 1000)
	// 	}
	// }

}
